// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"c473f394","977":"7c7cbdaf"}[chunkId] + ".chunk.js";
};